<template>
  <component :is="clienteData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="clienteData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>
    <form-edit-cliente
      :cliente-data="clienteData"
      class="pt-75"
      @handleSubmit="handleSubmit"
    />

  </component>
</template>

<script>
import {
  BAlert, BCard, BLink, BTab, BTabs,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import useNotifier from '@/composables/useNotifier'
import FormEditCliente from './FormEditCliente.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    FormEditCliente,
  },
  setup() {
    const notifier = useNotifier()
    const clienteData = ref({
      id_cliente: null,
      nome_cliente: '',
      tipo_pessoa_cliente: 'F',
      documento_cliente: '',
      ativo_cliente: 1,
      login_usuario: '',
      senha_usuario: '',
      endereco_cliente_endereco: '',
      numero_cliente_endereco: '',
      complemento_cliente_endereco: '',
      cep_cliente_endereco: '',
      bairro_cliente_endereco: '',
      cidade_cliente_endereco: '',
      inscricao_estadual_cliente_endereco: '',
      pais_id_cliente_endereco: 1,
      uf_id_cliente_endereco: null,
      id_grupousuario: null,
    })

    const resetClienteData = () => {
      clienteData.value = {
        id_cliente: null,
        nome_cliente: '',
        tipo_pessoa_cliente: 'F',
        documento_cliente: '',
        ativo_cliente: 1,
        login_usuario: '',
        senha_usuario: '',
        endereco_cliente_endereco: '',
        numero_cliente_endereco: '',
        complemento_cliente_endereco: '',
        cep_cliente_endereco: '',
        bairro_cliente_endereco: '',
        cidade_cliente_endereco: '',
        inscricao_estadual_cliente_endereco: '',
        pais_id_cliente_endereco: 1,
        uf_id_cliente_endereco: null,
        id_grupousuario: null,
      }
    }

    const handleSubmit = () => {
      if (clienteData.value.id_cliente !== null) {
        store.dispatch('appAdmCliente/updateCliente', clienteData.value)
          .then(() => {
            router.push({ name: 'app-admin-cliente' })
            notifier.success('Cliente atualizado com sucesso!')
          })
        return
      }
      store.dispatch('appAdmCliente/saveCliente', clienteData.value)
        .then(() => {
          router.push({ name: 'app-admin-cliente' })
          notifier.success('Cliente cadastrado com sucesso!')
        })
    }

    onMounted(() => {
      if (typeof router.currentRoute.params.id !== 'undefined') {
        store.dispatch('appAdmCliente/findClienteById', { id: router.currentRoute.params.id })
          .then(response => {
            const item = response.data
            clienteData.value = {
              id_cliente: item.id,
              nome_cliente: item.nome,
              tipo_pessoa_cliente: item.tipo_pessoa,
              documento_cliente: item.documento,
              ativo_cliente: item.ativo,
              login_usuario: item.usuarios[0]?.login,
              senha_usuario: item.usuarios[0]?.senha === undefined ? '*********' : '',
              endereco_cliente_endereco: item.cliente_enderecos[0]?.endereco,
              numero_cliente_endereco: item.cliente_enderecos[0]?.numero,
              complemento_cliente_endereco: item.cliente_enderecos[0]?.complemento,
              cep_cliente_endereco: item.cliente_enderecos[0]?.cep,
              bairro_cliente_endereco: item.cliente_enderecos[0]?.bairro,
              cidade_cliente_endereco: item.cliente_enderecos[0]?.cidade,
              inscricao_estadual_cliente_endereco: item.cliente_enderecos[0]?.inscricao_estadual,
              pais_id_cliente_endereco: 1,
              uf_id_cliente_endereco: item.cliente_enderecos[0]?.uf,
              id_grupousuario: item.usuarios[0]?.grupo?.id,
              id_usuario: item.usuarios[0]?.id,
              id_cliente_endereco: item.cliente_enderecos[0]?.id,
            }
          })
          .catch(error => {
            resetClienteData()
            notifier.error(error)
          })
      }
    })

    return {
      clienteData,
      handleSubmit,
      resetClienteData,
    }
  },
}
</script>

<style>

</style>
